import { React, useState, useEffect, useContext } from 'react'
import { CCard, CCol, CRow, CImage } from '@coreui/react'
import { cilPencil, cilTrash } from '@coreui/icons'
import AddIcon from '../../../assets/add-icon.svg'
import CIcon from '@coreui/icons-react'
import WebsiteTemplateModal from './websiteTemplateModal'
import TemplateNameModal from './templateNameModal'
import { useHistory } from 'react-router-dom'
import useAxios from 'axios-hooks'
import { TEMPLATE_V2_URL, BASE_TEMPLATE } from '../../utils/urls'
import { AppContext } from '../../context/app'
import { raiseToast } from 'src/views/utils/helper'
import { Dropdown } from 'react-bootstrap'
import OptionsBtn from '../../../assets/options-toggle-btn.svg'
import moment from 'moment'
import DeleteModal from 'src/components/DeleteModal/DeleteModal'
import PublishIcon from '../../../assets/publish-icon.svg'
import { isEmpty } from 'lodash'
import CustomImage from 'src/components/customImage/customImage'
import ServiceNotAllowed from '../serviceNotAllowed'

const TemplateListing = () => {
  const history = useHistory()
  const { setLoader, accountObj } = useContext(AppContext)
  const [newProjectModal, setNewProjectModal] = useState(false)
  const [baseTemplateInfo, setBaseTemplateInfo] = useState({})
  const [templateId, setTemplateId] = useState('')
  const [deleteModal, setDeleteModal] = useState(false)

  let isCustomTemplateAllowed = accountObj?.od_resource_allowances?.custom_template

  const [{ data: baseTemplateList, loading: baseTemplateListLoading }, baseTemplateListCall] =
    useAxios(
      {
        url: BASE_TEMPLATE,
        method: 'get',
      },
      { manual: true },
    )

  const [{ data: templateList, loading: templateListLoading }, templateListCall] = useAxios(
    {
      url: TEMPLATE_V2_URL,
      method: 'get',
    },
    { manual: true },
  )
  const [{ data: templateDelete, loading: templateDeleteLoading }, templateDeleteCall] = useAxios(
    {
      url: TEMPLATE_V2_URL,
      method: 'delete',
    },
    { manual: true },
  )

  useEffect(() => {
    setLoader(templateListLoading || baseTemplateListLoading || templateDeleteLoading)
  }, [templateListLoading, baseTemplateListLoading, templateDeleteLoading])

  useEffect(() => {
    templateListCall()
    baseTemplateListCall()
  }, [])

  useEffect(() => {
    if (templateDelete && templateDelete.success) {
      setDeleteModal(false)
      raiseToast('success', 'Deleted successfully')
      templateListCall()
    }
  }, [templateDelete])

  const cardStyles = {
    width: '21vw',
    height: '16vw',
    borderRadius: '0',
    boxShadow: ' 3px 3px 6px rgba(0,0,0,0.16)',
    aspectRatio: '45/34',
    overflow: 'hidden',
    postion: 'relative',
  }

  const onStartProject = (info) => {
    setNewProjectModal(false)
    setBaseTemplateInfo(info)
  }
  const onEdit = (id) => {
    if (!isCustomTemplateAllowed) {
      raiseToast('error', "You don't have Access to Custom Template!")
      return
    }
    if (id) {
      history.push(`/template-editor/${id}`)
    }
  }

  const handleDelete = () => {
    if (!isCustomTemplateAllowed) {
      raiseToast('error', "You don't have Access to Custom Template!")
      return
    }
    if (templateId) {
      templateDeleteCall({
        params: {
          template_id: templateId,
        },
      })
    }
  }

  // const handlePreview = () => {
  //   console.log('/template-preview')
  //   history.push('/template-preview')
  // }

  return (
    <>
      {isCustomTemplateAllowed ? (
        <div>
          <h4 style={{ marginTop: '5px' }}>Create your Website Template</h4>
          <p style={{ fontSize: '18px', color: '#707070' }}>
            Choose your website template and customize it as per your needs.{' '}
          </p>
          <CCard
            className="rounded-0 cards-container scrollbar position-relative"
            style={{
              padding: '4.2%',
            }}
          >
            <span className="position-absolute bottom-0 right-0 pb-2 pr-3">
              <i>*Applicable for website and web apps only</i>
            </span>
            <CRow xs={{ cols: 3, gutter: 4 }}>
              {templateList &&
                templateList?.data.map((info, idx) => (
                  <CCol key={idx}>
                    <CCard style={cardStyles}>
                      <div className="w-100 h-100 position-relative" style={{ zindex: 0 }}>
                        {info?.is_published && (
                          <img
                            src={PublishIcon}
                            className="position-absolute"
                            style={{ zIndex: 25, right: 0 }}
                            alt="PublishIcon"
                          />
                        )}
                        <CustomImage
                          imageUrl={info?.preview_s3_key?.website}
                          imgClass="w-100 position-absolute"
                          imgStyle={{ borderRadius: '0', zIndex: 0 }}
                          loaderClass="w-100 h-100"
                          loaderStyle={{ background: '#5A5A5A50' }}
                          imgAlt={'thumbnail'}
                        />
                      </div>
                      <div className="template-card-cardBody">
                        <div>
                          <span style={{ fontWeight: '500', color: '#191818', fontSize: '15px' }}>
                            {info.name}
                          </span>
                          <p style={{ color: '#747272', fontSize: '12px', marginBottom: '5px' }}>
                            Last modified: {moment(info.modified_date).format(' DD MMM YYYY')}
                          </p>
                        </div>
                        <Dropdown align="center" className="">
                          <Dropdown.Toggle variant="ghost" className="" id="revenue-dropdown">
                            {/* <CIcon icon={faEllipsisV} /> */}
                            <img src={OptionsBtn} alt="OptionsBtn" />
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item
                              style={{ cursor: 'pointer' }}
                              onClick={() => onEdit(info._id)}
                            >
                              <CIcon icon={cilPencil} size="sm" />
                              {'    Edit'}
                            </Dropdown.Item>
                            <Dropdown.Item
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                setTemplateId(info._id)
                                setDeleteModal(true)
                              }}
                            >
                              <CIcon icon={cilTrash} size="sm" />
                              {'    Delete'}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </CCard>
                  </CCol>
                ))}

              {/* Data in Above card will come from API */}

              <CCol style={{ cursor: 'pointer' }}>
                <CCard
                  style={{ ...cardStyles, backgroundColor: '#e8e8e8' }}
                  className="flex-column align-items-center justify-content-center"
                  onClick={
                    isCustomTemplateAllowed
                      ? () => setNewProjectModal(true)
                      : () => raiseToast('error', "You don't have Access to Custom Template!")
                  }
                >
                  <CImage
                    src={AddIcon}
                    style={{
                      marginBottom: '10px',
                    }}
                  />
                  <p style={{ color: '#747272' }}>Add New Project</p>
                </CCard>
              </CCol>
            </CRow>
          </CCard>
          {newProjectModal && (
            <WebsiteTemplateModal
              baseTemplateData={baseTemplateList?.data || []}
              onstart={onStartProject}
              onClose={() => setNewProjectModal(false)}
            />
          )}
          {!isEmpty(baseTemplateInfo) && (
            <TemplateNameModal
              baseTemplateInfo={baseTemplateInfo}
              onCancel={() => setBaseTemplateInfo({})}
            />
          )}
          {deleteModal && (
            <DeleteModal
              openModal={deleteModal}
              title={`Are you sure you want to Delete this Template?`}
              confirmButtonText={`Yes`}
              onCancel={() => {
                setTemplateId('')
                setDeleteModal(false)
              }}
              onConfirm={handleDelete}
            />
          )}
        </div>
      ) : (
        <ServiceNotAllowed />
      )}
    </>
  )
}

export default TemplateListing
